<template>
  <div>
    <b-button
      class="brand-icon text-center p-0 h-25 mb-3 text-color"
      variant="outline-secondary"
      block
      @click="openVoucherModal"
      :disabled="btnDisabled || state.system.isOffline"
      id="pay-method-voucher"
    >
      <img src="@/assets/images/giftvoucher.svg" alt="Redeem Coupon" />&nbsp;
      Redeem Voucher
    </b-button>
    <b-modal
      id="voucher-modal"
      ref="voucher-modal"
      hide-footer
      hide-header
      centered
      size="lg"
      no-close-on-backdrop
      no-close-on-esc
      @hide="closeVoucherModal"
    >
      <header>
        <b-row>
          <b-col md="10">
            <h6>Redeem Voucher</h6>
          </b-col>
          <b-col md="2">
            <font-awesome-icon
              style="cursor:pointer"
              @click="closeVoucherModal"
              class="float-right"
              :icon="['fas', 'times']"
            />
          </b-col>
        </b-row>
      </header>
      <b-row>
        <b-col md="6">
          <b-input-group
            class="mt-3 inputgroup-withappends"
            :class="mobile != '' ? 'active' : ''"
          >
            <template #prepend>
              <b-input-group-text>
                <font-awesome-icon
                  :icon="['fas', 'phone']"
                  class="phone-icon cursor-p"
              /></b-input-group-text>
            </template>
            <b-form-input
              type="number"
              v-model="mobile"
              placeholder="Enter phone to view vouchers"
              v-allow.number
              autocomplete="off"
              :disabled="$loading"
              @keypress.enter="getRedemptionList('by_mobile', mobile)"
            />
            <template #append>
              <b-input-group-text>
                <font-awesome-icon
                  :icon="['fas', 'times']"
                  class="cursor-p"
                  @click="clearField('mobile')"
              /></b-input-group-text>
            </template>
          </b-input-group>
        </b-col>
        <b-col md="6">
          <b-input-group
            class="mt-3 inputgroup-withappends"
            :class="barcode != '' ? 'active' : ''"
          >
            <template #prepend>
              <b-input-group-text>
                <font-awesome-icon :icon="['fas', 'barcode']" class="cursor-p"
              /></b-input-group-text>
            </template>
            <b-form-input
              v-model="barcode"
              placeholder="Scan or enter voucher code"
              :disabled="$loading"
              autocomplete="off"
              @keypress.enter="getRedemptionList('by_scan', barcode)"
            />
            <template #append>
              <b-input-group-text>
                <font-awesome-icon
                  :icon="['fas', 'times']"
                  class="cursor-p"
                  @click="clearField('barcode')"
              /></b-input-group-text>
            </template>
          </b-input-group>
        </b-col>
      </b-row>
      <b-row
        class="mt-3 activites-bar py-2 negative-margin"
        v-if="voucherList.length > 0"
      >
        <b-col cols="0" class="text-center">
          <div class="custom-check pl-2">
            <input
              type="checkbox"
              id="select-all-redeem-voucher"
              @click="checkBoxHandler('multiple', $event)"
            />
            <label class="mb-0 pl-0" for="select-all-redeem-voucher"></label>
          </div>
        </b-col>
        <b-col cols="0" class="text-center">#</b-col>
        <b-col cols="3">Voucher Code</b-col>
        <b-col cols="2">Applicability</b-col>
        <b-col cols="1">Balance</b-col>
        <b-col cols="2" class="pl-5">Redeemable</b-col>
        <b-col cols="2" class="large-col">Amount to Redeem</b-col>
      </b-row>
      <b-row
        class="py-3 voucher-list align-items-center negative-margin"
        v-for="(item, index) in voucherList"
        :key="index"
      >
        <b-col cols="0" class="text-center">
          <div class="custom-check pl-2">
            <input
              type="checkbox"
              :value="item.gv_id"
              :id="`gv-${item.gv_id}`"
              @click="checkBoxHandler('single', item)"
              :checked="item.selected"
            />
            <label class="mb-0 pl-0" :for="`gv-${item.gv_id}`"></label>
          </div>
        </b-col>
        <b-col cols="0" class="text-center" v-text="index + 1"></b-col>
        <b-col
          cols="3"
          v-text="helper.hideMiddleText(item.voucher_code)"
        ></b-col>
        <b-col cols="2">
          <b-link
            class="d-flex align-items-center"
            @click="applicableModal(item)"
            v-text="item.applicability"
          >
            <font-awesome-icon :icon="['fas', 'angle-right']" />
          </b-link>
        </b-col>
        <b-col cols="1" v-text="parseFloat(item.gift_value).toFixed(2)" />
        <b-col cols="2" class="pl-5">
          <span
            v-text="parseFloat(item.product_total_amount).toFixed(2)"
            class="mr-1"
          />
          <b-link
            v-b-tooltip.hover
            :title="item.warnings_msg"
            v-if="item.warnings_msg != ''"
          >
            <font-awesome-icon :icon="['fa', 'info-circle']" />
          </b-link>
        </b-col>
        <b-col cols="2" class="large-col">
          <b-input-group
            v-if="
              item.selected &&
                item.preset_details.allow_partial_redemption.config_value ==
                  'Yes'
            "
          >
            <b-form-input
              type="number"
              v-model="item.redeem_amount"
              autocomplete="off"
              v-negative-disable
              class="height-auto py-2"
            />
          </b-input-group>
          <span
            v-else-if="
              item.selected &&
                item.preset_details.allow_partial_redemption.config_value ==
                  'No'
            "
          >
            <span
              v-text="`${currencySymbol}${item.redeem_amount}`"
              class="mr-1"
            />
            <b-link
              v-b-tooltip.hover
              :title="item.preset_details.allow_partial_redemption.config_name"
            >
              <font-awesome-icon
                :icon="['fas', 'info-circle']"
                class="cursor-p fs-13"
            /></b-link>
          </span>
          <span v-else>-</span>
        </b-col>
      </b-row>
      <b-row class="mt-3 align-items-center">
        <b-col cols="7">
          <!-- <b-pagination
            class="mb-0"
            v-model="pagination.page"
            pills
            :total-rows="pagination.total_records"
            :per-page="pagination.perPageLimit"
            align="left"
            @change="getVoucherList"
          /> -->
        </b-col>
        <b-col cols="5" class="text-right" v-if="voucherList.length > 0">
          <div class="d-flex">
            <b-button
              class=""
              block
              id="remove-cart"
              variant="outline-danger"
              @click="clearVoucherList"
              >Clear All</b-button
            >
            <b-button
              class="ml-2"
              block
              variant="primary"
              id="redeem-voucher"
              :disabled="$loading || totalReedemValue == 0 || redeemBtnStatus"
              @click="redeemVoucher"
            >
              <span v-if="!$loading" v-text="`Redeem ${totalReedemValue}`" />
              <b-spinner small v-if="$loading"></b-spinner>
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal
      id="applicable-product-modal"
      ref="applicable-product-modal"
      hide-footer
      hide-header
      centered
      size="lg"
      no-close-on-backdrop
      no-close-on-esc
      @hide="voucherApplicableList = []"
    >
      <header>
        <b-row>
          <b-col md="10">
            <h6
              v-text="
                `Applicable Products for Voucher ${helper.hideMiddleText(
                  voucherApplicableList.voucher_code
                )}`
              "
            />
          </b-col>
          <b-col md="2">
            <font-awesome-icon
              style="cursor:pointer"
              class="float-right"
              :icon="['fas', 'times']"
              @click="$refs['applicable-product-modal'].hide()"
            />
          </b-col>
        </b-row>
      </header>

      <b-row class="mt-3 activites-bar py-2 negative-margin ">
        <b-col cols="0" class="text-center">#</b-col>
        <b-col cols="2">Barcode</b-col>
        <b-col cols="3">Product Name</b-col>
        <b-col cols="1">Quantity</b-col>
        <b-col cols="2">Unit Price</b-col>
        <b-col cols="1">Discount</b-col>
        <b-col cols="2 pl-5">Net Amount</b-col>
      </b-row>
      <b-row
        class="py-3 voucher-list align-items-center negative-margin"
        v-for="(item, index) in voucherApplicableList.order_details"
        :key="index"
      >
        <b-col cols="0" class="text-center" v-text="index + 1" />
        <b-col cols="2" v-text="item.barcode" />
        <b-col cols="3" v-text="item.item_name" />
        <b-col cols="1" v-text="item.qty" />
        <b-col
          cols="2"
          v-text="currencySymbol + parseFloat(item.unit_mrp).toFixed(2)"
        />
        <b-col
          cols="1"
          v-text="item.discount"
          :class="parseFloat(item.discount) == 0.0 ? 'text-muted' : ''"
        />
        <b-col
          cols="2 pl-5"
          v-text="currencySymbol + parseFloat(item.net_amount).toFixed(2)"
        />
      </b-row>
      <b-row class="mt-4 align-items-center">
        <b-col cols="9">
          <!-- <b-pagination
            class="mb-0"
            v-model="pagination.page"
            pills
            :total-rows="pagination.total_records"
            :per-page="pagination.perPageLimit"
            align="left"
            @change="getVoucherList"
          /> -->
        </b-col>
        <b-col cols="3" class="text-right">
          <b-button
            class=""
            block
            id="remove-cart"
            @click="$refs['applicable-product-modal'].hide()"
            variant="outline-danger"
            >Dismiss</b-button
          >
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
import * as msg from "../message";
import * as helper from "../helper";
import _ from "lodash";

export default {
  name: "redeem-voucher",
  props: { amount: String },
  data() {
    return {
      mobile: "",
      barcode: "",
      request: false,
      btnName: "",
      voucherList: [],
      voucherApplicableList: [],
    };
  },
  computed: {
    ...mapState({
      state: (state) => state,
    }),
    helper() {
      return helper;
    },
    totalReedemValue() {
      let data = 0;
      this.voucherList.forEach((item) => {
        if (item.selected && item.redeem_amount != "")
          data += parseFloat(item.redeem_amount);
      });
      return parseFloat(data).toFixed(2);
    },
    redeemBtnStatus() {
      let temp = false;

      if (this.state.billing.billing.total_payable < this.totalReedemValue)
        temp = true;
      return temp;
    },
    isOfflineEnabled() {
      let check = false;
      if (
        this.state.system.settings.vendor_app_menu.hasOwnProperty("offline") &&
        this.state.system.settings.vendor_app_menu.offline.status == 1
      )
        check = true;
      return check;
    },
    getOrderIdLength() {
      let length = this.state.system.settings.vendor_app_menu.offline
        .offline_invoice_id_format.order_id.name.length;
      return length;
    },
    btnDisabled() {
      let temp = false;
      let gv = _.find(
        this.state.billing.billing.order.summary.summary,
        (item) => {
          return item.name == "GIFT_VOUCHER";
        }
      );
      if (gv) temp = true;
      return temp;
    },
  },
  methods: {
    openVoucherModal() {
      this.mobile = "";
      this.barcode = "";
      this.voucherList = [];
      this.$refs["voucher-modal"].show();
    },
    closeVoucherModal() {
      this.$refs["voucher-modal"].hide();
    },
    applicableModal(e) {
      this.voucherApplicableList = e;
      this.$refs["applicable-product-modal"].show();
    },
    clearField(type) {
      if (type == "mobile") {
        this.mobile = "";
        this.voucherList = [];
      }
      if (type == "barcode") this.barcode = "";
    },
    getRedemptionList(type, by) {
      if ((type == "by_mobile" && by == "") || (type == "by_scan" && by == ""))
        return;

      if (type == "by_scan") {
        let voucher = _.find(this.voucherList, (item) => {
          return item.voucher_code == by;
        });

        if (voucher != undefined) {
          this.$store.commit("notifications/showAlert", {
            message: msg.VOUCHER_ALREADY_AVAILABLE,
            type: "danger",
          });
          this.$showAlert = true;
          return;
        }
      }
      this.$loading = true;
      this.$store
        .dispatch("giftVoucher/gvListRedeemption", { type: type, by: by })
        .then((res) => {
          this.$loading = false;
          if (type == "by_mobile") this.voucherList = res;
          else this.voucherList.unshift(res[0]);

          this.barcode = "";
        })
        .catch(() => (this.$loading = false));
    },
    checkBoxHandler(type, e) {
      if (type == "single") {
        if (e.selected) e.selected = false;
        else {
          e.selected = true;
          e.redeem_amount = this.getRedeemableAmt(e);
        }
        let count = 0;
        this.voucherList.forEach((item) => {
          if (item.selected) count++;
        });
        if (count == this.voucherList.length)
          document.getElementById("select-all-redeem-voucher").checked = true;
        else
          document.getElementById("select-all-redeem-voucher").checked = false;
      }

      if (type == "multiple")
        this.voucherList.forEach((item) => {
          item.selected = e.target.checked;
          item.redeem_amount = this.getRedeemableAmt(item);
        });
    },
    getRedeemableAmt(e) {
      let temp = 0;
      if (e.gift_value <= e.product_total_amount)
        temp = parseFloat(e.gift_value).toFixed(2);
      else if (e.product_total_amount < e.gift_value)
        temp = parseFloat(e.product_total_amount).toFixed(2);
      return temp;
    },
    redeemVoucher() {
      let temp = [];
      let arr = _.cloneDeep(this.voucherList);

      arr.forEach((item) => {
        if (
          item.selected &&
          item.redeem_amount != "" &&
          item.redeem_amount > 0
        ) {
          let i = item;
          delete i.order_details;
          delete i.selected;
          delete i.warnings_msg;
          delete i.applicability;
          temp.push(i);
        }
      });
      // console.log(temp);

      // return;

      if (temp.length == 0) return;

      this.$loading = true;

      let order_id = "";
      if (this.isOfflineEnabled) {
        order_id = this.state.billing.billing.invoice_no;
        order_id = order_id.substring(order_id.length - this.getOrderIdLength);
      }

      let data = Object.assign(
        {
          amount: this.totalReedemValue,
          redeem_data: JSON.stringify(temp),
          t_order_id: "",
          order_id: this.state.billing.billing.order.data.order_id,
          pay_id: "",
          method: "GIFT_VOUCHER",
          invoice_id: "",
          bank: "",
          wallet: "",
          vpa: "",
          error_description: "",
          status: "success",
          address_id: "",
          payment_gateway_status: "",
          payment_gateway_type: "GIFT_VOUCHER",
          cash_collected: "",
          cash_return: "",
          lay_by_total: "",
          lay_by_remark: "",
          transaction_sub_type: "",
          url: "/save-payment",
          gateway_response: "",
          payment_gateway_device_type: "",
          invoice_seq: order_id,
          remark: this.state.billing.billing.remark,
        },
        this.customerData
      );

      this.$store
        .dispatch("billing/savePayment", data)
        .then(() => {
          this.$refs["voucher-modal"].hide();
          this.$loading = false;
        })
        .catch(() => (this.$loading = false));
    },
    clearVoucherList() {
      this.barcode = "";
      this.mobile = "";
      this.voucherList = [];
    },
  },
};
</script>

<style lang="scss" scoped>
// .bg-black {
//   background-color: #000;
//   border: 1px #606060 solid;
//   color: #fff;
// }
// .theme-light .bg-black {
//   background-color: transparent;
//   border: 1px #c0c0c0 solid;
//   color: #404040;
// }
.h-25 {
  height: 40px !important;
}
.phone-icon {
  transform: rotate(87deg);
}
.fa-times {
  transition: 0.3 ease-in;
}
.voucher-list {
  border-bottom: 1px solid $dark-card-title-header;
}
</style>
